





















































































/* eslint-disable object-curly-newline, no-bitwise, no-restricted-syntax, camelcase */
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import Info, { typeInfo } from './Service/Info';

@Component
export default class rolePermissionInfo extends Vue {
  @Prop()
  contentSize!: Object;

  @Prop()
  node!: any;

  @Prop()
  role_node_f!: any;

  private role: any = {}; // 角色的資料

  private checkedData: any = [];

  public loading: boolean = true;

  private dialogRole: boolean = false;

  public getInfo() {
    this.loading = true;
    const getter = new Info(this.$route.params.p5_role_id);
    getter.get().then((d) => {
      this.node = d.node_f;
      this.role = d.role;
      this.role_node_f = d.role_node_f;
      this.loading = false;
    });
  }

  /** 檢查是否有該權限存在 */
  private hasPermission(nodeCrud: number[] = [], crud: number): boolean {
    const self = this;
    const exist = nodeCrud.filter((c:any) => c === crud);
    if (exist.length) {
      return true;
    }
    return false;
  }
}
